import { useItemsPerSlide } from '@tryhackme/thm-ui-components';
import { useTotalUsers } from 'src/common/hooks/use-total-users';
import { testimonials } from 'src/features/home/components/community/community.constants';
import { StyledCarousel, StyledCarouselContainer, StyledCloudWrapper, StyledCommunityWrapper, StyledImage, StyledImageContainer, StyledRegisteredUsersAndCloudWrapper, StyledRegisteredUsersContainer, StyledRegisteredUsersNumber, StyledRegisteredUsersText, StyledTitleAndDescriptionWrapper, StyledTopWrapper } from 'src/features/home/components/community/community.styles';
import { Title } from 'src/features/home/components/title/title';
import { StyledDescription } from 'src/features/home/home.styles';
import { ReactComponent as Cloud } from 'src/images/svgs/cloud.svg';
import type { ItemsPerSlide } from './community.types';
export const Community = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const itemsPerSlide = useItemsPerSlide() as ItemsPerSlide;
  const {
    totalUsers
  } = useTotalUsers();
  const quoteCarousalItems = testimonials.map(testimonial => {
    const firstImage = <StyledImageContainer>
        <StyledImage key={testimonial?.[0]} src={testimonial?.[0] ?? ''} alt="TryHackMe user testimonial" />
      </StyledImageContainer>;
    if (testimonial.length === 2) {
      const secondImage = <StyledImageContainer>
          <StyledImage key={testimonial?.[1]} src={testimonial?.[1] ?? ''} alt="TryHackMe user testimonial" />
        </StyledImageContainer>;
      return [firstImage, secondImage];
    }
    return [firstImage];
  });
  return <StyledCommunityWrapper data-sentry-element="StyledCommunityWrapper" data-sentry-component="Community" data-sentry-source-file="community.tsx">
      <StyledTopWrapper data-sentry-element="StyledTopWrapper" data-sentry-source-file="community.tsx">
        <StyledTitleAndDescriptionWrapper data-sentry-element="StyledTitleAndDescriptionWrapper" data-sentry-source-file="community.tsx">
          <Title title="Community" isLeft data-sentry-element="Title" data-sentry-source-file="community.tsx" />
          <StyledDescription isLeft fullWidth data-sentry-element="StyledDescription" data-sentry-source-file="community.tsx">
            Connect with other like-minded cyber security students and join our huge community. Ask questions, share
            knowledge and meet people on the same journey as you.
          </StyledDescription>
        </StyledTitleAndDescriptionWrapper>
        <StyledRegisteredUsersAndCloudWrapper data-sentry-element="StyledRegisteredUsersAndCloudWrapper" data-sentry-source-file="community.tsx">
          <StyledRegisteredUsersContainer data-sentry-element="StyledRegisteredUsersContainer" data-sentry-source-file="community.tsx">
            <StyledRegisteredUsersNumber data-sentry-element="StyledRegisteredUsersNumber" data-sentry-source-file="community.tsx">{totalUsers}</StyledRegisteredUsersNumber>
            <StyledRegisteredUsersText data-sentry-element="StyledRegisteredUsersText" data-sentry-source-file="community.tsx">Registered Users</StyledRegisteredUsersText>
          </StyledRegisteredUsersContainer>
          <StyledCloudWrapper data-sentry-element="StyledCloudWrapper" data-sentry-source-file="community.tsx">
            <Cloud data-testid="cloud-svg" data-sentry-element="Cloud" data-sentry-source-file="community.tsx" />
          </StyledCloudWrapper>
        </StyledRegisteredUsersAndCloudWrapper>
      </StyledTopWrapper>
      <StyledCarouselContainer data-testid="quote-carousel" data-sentry-element="StyledCarouselContainer" data-sentry-source-file="community.tsx">
        <StyledCarousel isQuoteCarousel items={quoteCarousalItems} itemsPerSlide={itemsPerSlide} showDots showBackButton={false} showNextButton={false} color="secondary" data-sentry-element="StyledCarousel" data-sentry-source-file="community.tsx" />
      </StyledCarouselContainer>
    </StyledCommunityWrapper>;
};